// ═══════════════════════════════════════════════
//   BOOTSTRAP — entry point. Side-effect imports load every module
//   in dependency order so each can read globals (window.*) populated
//   by previous modules. esbuild bundles everything into dist/app.js.
// ═══════════════════════════════════════════════

// ── Foundation ──
import './data.js';
import './data-konmail.js';
import './state.js';
import './persistence.js';
import './db.js';
import './infra.js';
import './windows.js';
import './auth.js';

// ── Features (one window/app each) ──
import './features/games-remote.js';
import './features/staff.js';
import './features/missions.js';
import './features/catalog.js';
import './features/daily.js';
import './features/files-shop.js';
import './features/scores.js';
import './features/audio.js';
import './features/quiz.js';
import './features/tutorial.js';
import './features/postgame.js';
import './features/gacha.js';
import './features/tama.js';
import './features/profile.js';
import './features/camera.js';
import './features/bakery.js';
import './features/konmail.js';
import './features/logbook.js';

// ── Games (launcher first; rest depend on canvas/ctx + helpers it exposes) ──
import './games/launcher.js';
import './games/stars.js';
import './games/memory.js';
import './games/restock.js';
import './games/emails.js';
import './games/workers.js';
import './games/shooter.js';
import './games/stacker.js';
import './games/onigiri.js';
import './games/slider.js';
import './games/unscramble.js';
import './games/merge.js';
import './games/suika.js';
import './games/konbisnake.js';
import './games/maze.js';

// ── Kick off the boot sequence. initBoot checks maintenance first; if the
//    server is in maintenance the splash never shows. Otherwise it falls
//    through to bootNext like before. Polling keeps the UI reactive to
//    server_state changes without a manual reload.
setTimeout(window.initBoot, 100);
